import { Model } from 'libx'
import { observable, computed } from 'mobx'

export default class Card extends Model {
  @observable id

  @computed get isDefaultSource () {
    const record = this.rootStore.billingStore.customerRecord
    if (!record) {
      return false
    }

    return record.default_source === this.id
  }
}



// WEBPACK FOOTER //
// ./src/client/domain/Card.js